// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"105":"240d085c","760":"8eb94e21","896":"551abb7f","945":"4a9882ca"}[chunkId] + ".chunk.js";
};